export default "__VITE_ASSET__4M5T1DPA__"